import C1 from './c1';
import Capacitor from './capacitor';
import Inductor from './inductor';
import R3 from './r3';
import R4 from './r4';
import Resistor from './resistor';

export function createC1(c1IdealValue, capacitorMinimumLimitMultiplier, capacitorMaximumLimitMultiplier, sizing) {
  let result = C1.create({
    idealValue: c1IdealValue,
    capacitorMinimumLimitMultiplier: capacitorMinimumLimitMultiplier,
    capacitorMaximumLimitMultiplier: capacitorMaximumLimitMultiplier,
    sizing: sizing,
  });

  return result;
}

export function createC1MinAndMaxDefined(c1IdealValue, minimum, maximum, sizing) {
  let result = C1.create({
    idealValue: c1IdealValue,
    minimum: minimum,
    maximum: maximum,
    sizing: sizing,
  });

  return result;
}

export function createC2(
  c2IdealValue,
  capacitorMinimumLimitMultiplier,
  capacitorMaximumLimitMultiplier,
  sizing,
  rcRatioInverse,
) {
  let result = Capacitor.create({
    idealValue: c2IdealValue,
    capacitorMinimumLimitMultiplier: capacitorMinimumLimitMultiplier,
    capacitorMaximumLimitMultiplier: capacitorMaximumLimitMultiplier,
    sizing: sizing,
    rcRatio: rcRatioInverse,
  });
  return result;
}

export function createC5(
  c5IdealValue,
  capacitorMinimumLimitMultiplier,
  capacitorMaximumLimitMultiplier,
  sizing,
  rcRatioInverse,
) {
  let result = Capacitor.create({
    idealValue: c5IdealValue,
    capacitorMinimumLimitMultiplier: capacitorMinimumLimitMultiplier,
    capacitorMaximumLimitMultiplier: capacitorMaximumLimitMultiplier,
    sizing: sizing,
    rcRatio: rcRatioInverse,
  });
  return result;
}

export function createR1(
  r1IdealValue,
  capacitorMinimumLimitMultiplier,
  capacitorMaximumLimitMultiplier,
  sizing,
  rcRatioInverse,
) {
  let result = Resistor.create({
    idealValue: r1IdealValue,
    capacitorMinimumLimitMultiplier: capacitorMinimumLimitMultiplier,
    capacitorMaximumLimitMultiplier: capacitorMaximumLimitMultiplier,
    sizing: sizing,
    rcRatio: rcRatioInverse,
  });

  return result;
}

export function createR1MinAndMaxDefined(r1IdealValue, minimum, maximum, sizing, rcRatioInverse) {
  let result = Resistor.create({
    idealValue: r1IdealValue,
    minimum: minimum,
    maximum: maximum,
    sizing: sizing,
    rcRatio: rcRatioInverse,
  });

  return result;
}

export function createR2(
  r2IdealValue,
  capacitorMinimumLimitMultiplier,
  capacitorMaximumLimitMultiplier,
  sizing,
  rcRatioInverse,
) {
  return Resistor.create({
    idealValue: r2IdealValue,
    capacitorMinimumLimitMultiplier: capacitorMinimumLimitMultiplier,
    capacitorMaximumLimitMultiplier: capacitorMaximumLimitMultiplier,
    sizing: sizing,
    rcRatio: rcRatioInverse,
  });
}

export function createR2MinMaxDefined(r2IdealValue, minimum, maximum, sizing, rcRatioInverse) {
  return Resistor.create({
    idealValue: r2IdealValue,
    minimum: minimum,
    maximum: maximum,
    sizing: sizing,
    rcRatio: rcRatioInverse,
  });
}

export function createR3(r3NominalValue, resistorMinimumLimitMultiplier, resistorMaximumLimitMultiplier) {
  let result = R3.create({
    idealValue: r3NominalValue,
    resistorMinimumLimitMultiplier: resistorMinimumLimitMultiplier,
    resistorMaximumLimitMultiplier: resistorMaximumLimitMultiplier,
  });
  return result;
}

export function createR4(r4IdealValue, resistorMinimumLimitMultiplier, resistorMaximumLimitMultiplier) {
  let result = R4.create({
    idealValue: r4IdealValue,
    resistorMinimumLimitMultiplier: resistorMinimumLimitMultiplier,
    resistorMaximumLimitMultiplier: resistorMaximumLimitMultiplier,
  });

  return result;
}

export function createR4FromR3AndGain(r3Value, gain, resistorMinimumLimitMultiplier, resistorMaximumLimitMultiplier) {
  let r4IdealValue = r3Value * (gain - 1);
  let result = createR4(r4IdealValue, resistorMinimumLimitMultiplier, resistorMaximumLimitMultiplier);
  return result;
}

export function createR5(
  r5IdealValue,
  capacitorMinimumLimitMultiplier,
  capacitorMaximumLimitMultiplier,
  sizing,
  rcRatioInverse,
) {
  return Resistor.create({
    idealValue: r5IdealValue,
    capacitorMinimumLimitMultiplier: capacitorMinimumLimitMultiplier,
    capacitorMaximumLimitMultiplier: capacitorMaximumLimitMultiplier,
    sizing: sizing,
    rcRatio: rcRatioInverse,
  });
}

export function createInductor(l1IdealValue, minimum, maximum, rcRatioInverse) {
  var result = Inductor.create({
    idealValue: l1IdealValue,
    minimum: minimum,
    maximum: maximum,
    rcRatio: rcRatioInverse,
  });
  return result;
}
